/**
 * Open Demand cross-component events
 *
 * The Open Demand list owns the authoritative resource-request state (it
 * refetches after accept / decline and tracks locally generated plans), while
 * the nav badge lives in AppSidebar. The list broadcasts its count of requests
 * still awaiting action so the badge does not go stale once requests are
 * processed.
 */

export const OPEN_DEMAND_COUNT_EVENT = 'openDemand:openCountChanged';

export type OpenDemandCountEvent = CustomEvent<number>;
